import { Suspense, useMemo } from "react";
import { useDataFetch } from "../../../hooks/useDataFetch2";
import Tabla from "../../../components/ui/materialui/serverSideTable";
import MButton from "../../../components/inputs/yup/materialui/mButton";
import { useColumnSolicitudesLiquidadas } from "../utils/columnsSolicitudesLiquidadas";
import { StateViewInterface } from "../interfaces/stateViews.interface";
import TableHeader from "../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { EstadoSolicitudPrepago, TipoFuncionalidad } from "../../../utils/enums";
import { RespuestaSolicitudesPrepagoDto } from "../models";
import { PermissionGuard } from "../../../components/auth/ProtectedRoute";

const urlTabla = `siscred-api-cartera-total/v1/prepago/obtener-liquidacion`;

interface Props {
    idMutuo: string;
    setViewToShow: (nameView: keyof StateViewInterface) => void;
    setIdSolicitud: (idSolicitud: number) => void;
    setSolicitud: (solicitud: RespuestaSolicitudesPrepagoDto|null) => void;
    isDesactivado?: boolean;
}

const TableSolicitudesLiquidadas = ({ idMutuo, setViewToShow, setIdSolicitud, setSolicitud, isDesactivado }: Props) => {

    const params = new URLSearchParams();
    params.set("mutuoId", idMutuo.toString());
    params.set("estados", `${EstadoSolicitudPrepago.LIQUIDADO},${EstadoSolicitudPrepago.RECAUDADA}`);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const irARecaudarSolicitud = (solicitud: RespuestaSolicitudesPrepagoDto) => {
        setSolicitud(solicitud);
        setViewToShow("showGenerarRecaudacion")
    }

    const irADesrecaudarSolicitud = (idSolicitud: number) => {
        setIdSolicitud(idSolicitud);
        setViewToShow("showGenerarDesrecaudacion")
    }

    const irARemesarSolicitud = (idSolicitud: number) => {
        setIdSolicitud(idSolicitud);
        setViewToShow("showRemesarPrepago")
    }

    const { COLUMNS } = useColumnSolicitudesLiquidadas({ controlTabla: dataTable, irARecaudarSolicitud, irADesrecaudarSolicitud, irARemesarSolicitud, isDesactivado});
    const columns = useMemo(() => COLUMNS, [dataTable]);

    return (
        <Suspense>
            <Tabla
                columns={columns}
                control={dataTable}
                url={urlTabla}
                titulo={
                    <TableHeader
                        title=""
                        control={dataTable}
                        buttonExport={
                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                            <MButton
                                type="button"
                                variant="outlined"
                                onClick={() => exportExcel(dataTable.data, columns, "solicitudesGeneradas")}
                                startIcon={<SummarizeTwoToneIcon />}
                            >
                                Exportar
                            </MButton>
                            </PermissionGuard>
                        }
                    />
                }
            />
        </Suspense>
    )
}

export default TableSolicitudesLiquidadas;